export default class Faq {
    constructor() {
    }

    init(){
        const faqItem = document.querySelectorAll('.faqs__faq');
        if(faqItem) {
            faqItem.forEach(element => {
                element.addEventListener('click', () => {
                    element.classList.toggle('opened');
                });
            })
        }
    }
};
new Faq().init();